import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/JobDetails/JobDetails.tsx");
